<template>
  <div class="dovemed-container storyContainer">
    <div class="dovemed-wrapper text-center signup-page">
      <div class="signup-container">
        <div class="your-story">
          <div class="headingWrapper">
            <h2 class="hyper-link storyHeading">
              {{ authUser.user.role === "caregiver" ? "Patient's Story" : "Your Story" }}
            </h2>
            <!-- <i
              class="fa fa-question-circle question-icon"
              aria-hidden="true"
              :style="`color:#2A71D4 !important`"
            ></i> -->
          </div>
          <div class="subHeading">
            {{ authUser.user.role === "caregiver" ? "Tell us about the patient" : "Tell us about yourself" }}
          </div>
        </div>
        <div class="row storyContent">
          <div class="p-0 col-12 text-left">
            <a-textarea
              :placeholder="
                authUser.user.role === 'patient'
                  ? 'Sample text: I am a retired school teacher. I have been living with the condition for the past 12 years. Medication and therapy are helping me cope with the condition. Some days are worse than the others, but generally I am able to cope well. I receive ample understanding and emotional support from those around me, and I am thankful to my family, friends, and well-wishers. I feel I can share my experiences and knowledge to help others manage their condition better. I look forward to interacting with many of you. Cheers!'
                  : 'Sample text: I am representing my relative (son or mother, etc.) on this platform who has been living with this chronic condition for the past three years. Medication and therapy are helping him/her cope well with the condition, even though some days are worse than others. He/she receives ample understanding and emotional support from those, and we are thankful to our family, friends, and well-wishers. I feel I can share a part of his/her experiences to help others manage their condition better. I look forward to interacting with many of you. Cheers!'
              "
              :rows="8"
              v-model="story"
              :maxlength="max"
            />
            <p class="text-right mb-0">
              <small class="font-light"> {{ story.length }}/{{ max }} </small>
            </p>
          </div>
        </div>
        <div :class="`buttons-group mt-5 text-right col-12 mb-5 ${story.length ? 'last-2-btns' : ''}`">
          <!-- <router-link to='' @click.native="skip"> -->
          <!-- <button class='dovemed-button hyper-link' @click="skip">SKIP STEP</button> -->
          <div class="float-left primary-button skipLater" @click="skip" :style="{ color: getPrimaryColor(), cursor: 'pointer', display: story.length !== 0 ? 'none' : 'inline-block' }">
            Skip for later
          </div>
          <!-- </router-link> -->
          <!-- <router-link
            :to="{ path: 'other_symptoms', query: { role: 'patient' } }"
          > -->
          <router-link :to="{ name: 'OtherSymptonsSignup', query: { role: 'patient' } }">
            <button
              class="dovemed-button hyper-link treatment-button"
              :style="{
                border: '1px solid #E2E8F0',
                color: '#47556E',
                background: '#E2E8F0',
              }"
            >
              <!-- @click="
              () =>
                this.$router.push({
                  name: 'OtherSymptonsSignup',
                  query: { role: this.formResponses.role }
                })
            " -->
              <!-- @click="$router.go(-1)" -->
              Back
            </button>
          </router-link>
          <!-- <router-link to=""> -->
          <a-button
            class="dovemed-button font-white ml-1 primary-button treatment-button nxt-btn"
            :loading="loading"
            :disabled="story.length === 0"
            type="submit"
            :style="{
              background: getPrimaryColor(),
              opacity: story.length === 0 ? '0.3' : '1',
              height: '47px !important',
              transform: 'translateY(-1px)',
            }"
            @click="handleSubmit"
          >
            Next
          </a-button>
          <!-- </router-link> -->
        </div>
      </div>
    </div>
    <!-- <EmailVerifyModal ref="emailVerifyModal" /> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex"
// import EmailVerifyModal from "../../Modals/EmailVerification"
// import { RepositoryFactory } from "../../../repositories/RepositoryFactory"

export default {
  name: "UserYourStory",
  data() {
    return { story: "", max: 2000, loading: false }
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      currentCircle: "Circle/currentCircle",
    }),
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  // components: {
  //   EmailVerifyModal,
  // },
  methods: {
    async handleSubmit() {
      this.loading = true
      const user = JSON.parse(localStorage.getItem("user"))
      const payload = { mini_bio: this.story }
      const headers = { Authorization: `Bearer ${user.user.token}` }
      const url = `${process.env.BASE_API_URL}/${user.user.role === "patient" ? "normaluser" : user.user.role}/?user_id=${user.user.id}`
      await this.$store.dispatch("Signup/updateNormalUser", { url, payload, headers })

      this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
      // this.$router.push({ name: "AllCircles" });
      // this.logout(); // JP: This line commented will not logout

      this.$notification.success({ message: "Success", description: "User registration successful." })
    },
    skip() {
      this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
      // this.$router.push({ name: "AllCircles" });
      // this.logout(); // JP: This line commented will not logout

      // this.$router.push({path: `/${circle.id}/home/activity`})
      this.$notification.success({ message: "Success", description: "User registration successful." })
    },
  },
}
</script>

<style scoped lang="scss">
.storyContainer {
  margin: 48px 0 0 0;
  @media screen and (max-width: 900px) {
    margin-top: 16px !important;
  }
  .signup-container {
    width: 540px;
    @media screen and (max-width: 900px) {
      width: auto;
    }
  }
  .your-story {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .headingWrapper {
    display: flex;
    .question-icon {
      font-size: 20px;
      margin: 0 0 0 6px;
      cursor: pointer;
    }
  }
  .subHeading {
    color: #647490;
    font-weight: 700;
    font-size: 16px;
  }
  .storyHeading {
    color: #1e2945 !important;
    font-weight: 700;
    font-size: 36px;
  }
  .storyContent {
    margin: 72px 0 0 0;
  }
  .textarea.ant-input {
    padding: 12px 16px;
    max-width: 540px;
  }
}
.skipLater {
  font-weight: 700;
  font-size: 14px;
  margin-top: 15px;
  @media screen and (max-width: 900px) {
    margin-top: 12px;
  }
}
.treatment-button {
  font-weight: 700;
  font-size: 14px;
  border-radius: 6px;
  @media screen and (max-width: 900px) {
    padding: 10px 50px;
  }

  @media screen and (max-width: 600px) {
    padding: 10px 25px;
  }
}
.dovemed-button {
  padding: 12px 24px;

  @media screen and (max-width: 900px) {
    padding: 12px 37.5px;
  }
}
.buttons-group {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
@media screen and (max-width: 900px) {
  .last-2-btns {
    display: flex;
    gap: 10px;
    a {
      width: 50% !important;
      button {
        width: 100% !important;
      }
    }
    .nxt-btn {
      width: 50% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/UserProfile/YourStory.vue